// Copyright 2020
//   __  __                       _           _     _   _            _ _   _
//  |  \/  | ___   ___  _ __  ___| |__   ___ | |_  | | | | ___  __ _| | |_| |__
//  | |\/| |/ _ \ / _ \| '_ \/ __| '_ \ / _ \| __| | |_| |/ _ \/ _` | | __| '_ \
//  | |  | | (_) | (_) | | | \__ \ | | | (_) | |_  |  _  |  __/ (_| | | |_| | | |
//  |_|  |_|\___/ \___/|_| |_|___/_| |_|\___/ \__| |_| |_|\___|\__,_|_|\__|_| |_|
//
//  All Rights Reserved.
//
// NOTICE:  All information contained herein is, and remains
// the property of Moonshot Health Incorporated and its suppliers,
// if any.  The intellectual and technical concepts contained
// herein are proprietary to Adobe Systems Incorporated
// and its suppliers and may be covered by U.S. and Foreign Patents,
// patents in process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Moonshot Health Incorporated.

// @generated by protoc-gen-connect-web v0.11.0 with parameter "target=js,import_extension=none"
// @generated from file msh/service/v1/structure_manager.proto (package msh.service.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { AddContactRequest, AddContactResponse, AddFloorRequest, AddFloorResponse, AddRoomRequest, AddRoomResponse, AssignResidentRequest, AssignResidentResponse, CalculateStatisticsRequest, CalculateStatisticsResponse, CreateBuildingRequest, CreateBuildingResponse, CreateStructureRequest, CreateStructureResponse, GetActivityLevelHistoryRequest, GetActivityLevelHistoryResponse, GetADLBuildingEventsRequest, GetADLBuildingEventsResponse, GetADLStructureEventsRequest, GetADLStructureEventsResponse, GetAirQualitiesRequest, GetAirQualitiesResponse, GetBuildingAlertsRequest, GetBuildingAlertsResponse, GetBuildingsRequest, GetBuildingsResponse, GetDeviceOnlineCountRequest, GetDeviceOnlineCountResponse, GetFloorsRequest, GetFloorsResponse, GetHRHistoryRequest, GetHRHistoryResponse, GetHumiditiesRequest, GetHumiditiesResponse, GetLightIntensitiesRequest, GetLightIntensitiesResponse, GetPressuresRequest, GetPressuresResponse, GetRespirationHistoryRequest, GetRespirationHistoryResponse, GetRoomsRequest, GetRoomsResponse, GetSensorHistoryRequest, GetSensorHistoryResponse, GetStructuresRequest, GetStructuresResponse, GetTemperaturesRequest, GetTemperaturesResponse, SendCancelRecordingStructureCommandRequest, SendCancelRecordingStructureCommandResponse, SendStartRecordingStructureCommandRequest, SendStartRecordingStructureCommandResponse, SendStopRecordingStructureCommandRequest, SendStopRecordingStructureCommandResponse, SetWanderingSettingsRequest, SetWanderingSettingsResponse, StartTestCoverageRequest, StartTestCoverageResponse, StopTestCoverageRequest, StopTestCoverageResponse, StopTestCoverageTimeoutRequest, StopTestCoverageTimeoutResponse, UpdateBuildingRequest, UpdateBuildingResponse, UpdateStructureRequest, UpdateStructureResponse } from "./structure_manager_pb";
import { MethodKind } from "@bufbuild/protobuf";

/**
 * For business account only. Adds a building to an account.
 *
 * @generated from service msh.service.v1.BuildingManager
 */
export const BuildingManager = {
  typeName: "msh.service.v1.BuildingManager",
  methods: {
    /**
     * Only an account manager can add a building
     *
     * @generated from rpc msh.service.v1.BuildingManager.CreateBuilding
     */
    createBuilding: {
      name: "CreateBuilding",
      I: CreateBuildingRequest,
      O: CreateBuildingResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc msh.service.v1.BuildingManager.GetBuildings
     */
    getBuildings: {
      name: "GetBuildings",
      I: GetBuildingsRequest,
      O: GetBuildingsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Update building
     *
     * @generated from rpc msh.service.v1.BuildingManager.UpdateBuilding
     */
    updateBuilding: {
      name: "UpdateBuilding",
      I: UpdateBuildingRequest,
      O: UpdateBuildingResponse,
      kind: MethodKind.Unary,
    },
    /**
     * For business account only. Adds a Floor to an account.
     * Only an account manager of the building can add a floor
     *
     * @generated from rpc msh.service.v1.BuildingManager.AddFloor
     */
    addFloor: {
      name: "AddFloor",
      I: AddFloorRequest,
      O: AddFloorResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc msh.service.v1.BuildingManager.GetFloors
     */
    getFloors: {
      name: "GetFloors",
      I: GetFloorsRequest,
      O: GetFloorsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Create an alert contact
     *
     * @generated from rpc msh.service.v1.BuildingManager.AddContact
     */
    addContact: {
      name: "AddContact",
      I: AddContactRequest,
      O: AddContactResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Get online device count
     *
     * @generated from rpc msh.service.v1.BuildingManager.GetDeviceOnlineCount
     */
    getDeviceOnlineCount: {
      name: "GetDeviceOnlineCount",
      I: GetDeviceOnlineCountRequest,
      O: GetDeviceOnlineCountResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Get alerts related to a building
     *
     * @generated from rpc msh.service.v1.BuildingManager.GetBuildingAlerts
     */
    getBuildingAlerts: {
      name: "GetBuildingAlerts",
      I: GetBuildingAlertsRequest,
      O: GetBuildingAlertsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Get ADL events for a building
     *
     * @generated from rpc msh.service.v1.BuildingManager.GetADLBuildingEvents
     */
    getADLBuildingEvents: {
      name: "GetADLBuildingEvents",
      I: GetADLBuildingEventsRequest,
      O: GetADLBuildingEventsResponse,
      kind: MethodKind.Unary,
    },
  }
};

/**
 * @generated from service msh.service.v1.StructureManager
 */
export const StructureManager = {
  typeName: "msh.service.v1.StructureManager",
  methods: {
    /**
     * @generated from rpc msh.service.v1.StructureManager.CreateStructure
     */
    createStructure: {
      name: "CreateStructure",
      I: CreateStructureRequest,
      O: CreateStructureResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc msh.service.v1.StructureManager.GetStructures
     */
    getStructures: {
      name: "GetStructures",
      I: GetStructuresRequest,
      O: GetStructuresResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc msh.service.v1.StructureManager.UpdateStructure
     */
    updateStructure: {
      name: "UpdateStructure",
      I: UpdateStructureRequest,
      O: UpdateStructureResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc msh.service.v1.StructureManager.AssignResident
     */
    assignResident: {
      name: "AssignResident",
      I: AssignResidentRequest,
      O: AssignResidentResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc msh.service.v1.StructureManager.AddRoom
     */
    addRoom: {
      name: "AddRoom",
      I: AddRoomRequest,
      O: AddRoomResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc msh.service.v1.StructureManager.GetRooms
     */
    getRooms: {
      name: "GetRooms",
      I: GetRoomsRequest,
      O: GetRoomsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc msh.service.v1.StructureManager.GetADLStructureEvents
     */
    getADLStructureEvents: {
      name: "GetADLStructureEvents",
      I: GetADLStructureEventsRequest,
      O: GetADLStructureEventsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Start a raw data recording on all devices of a structure
     *
     * @generated from rpc msh.service.v1.StructureManager.SendStartRecordingStructureCommand
     */
    sendStartRecordingStructureCommand: {
      name: "SendStartRecordingStructureCommand",
      I: SendStartRecordingStructureCommandRequest,
      O: SendStartRecordingStructureCommandResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Stop a raw data recording on all devices of a structure
     *
     * @generated from rpc msh.service.v1.StructureManager.SendStopRecordingStructureCommand
     */
    sendStopRecordingStructureCommand: {
      name: "SendStopRecordingStructureCommand",
      I: SendStopRecordingStructureCommandRequest,
      O: SendStopRecordingStructureCommandResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Cancel a raw data recording on all devices of a structure
     *
     * @generated from rpc msh.service.v1.StructureManager.SendCancelRecordingStructureCommand
     */
    sendCancelRecordingStructureCommand: {
      name: "SendCancelRecordingStructureCommand",
      I: SendCancelRecordingStructureCommandRequest,
      O: SendCancelRecordingStructureCommandResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Get activity level history
     *
     * @generated from rpc msh.service.v1.StructureManager.GetActivityLevelHistory
     */
    getActivityLevelHistory: {
      name: "GetActivityLevelHistory",
      I: GetActivityLevelHistoryRequest,
      O: GetActivityLevelHistoryResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Get respiration history
     *
     * @generated from rpc msh.service.v1.StructureManager.GetRespirationHistory
     */
    getRespirationHistory: {
      name: "GetRespirationHistory",
      I: GetRespirationHistoryRequest,
      O: GetRespirationHistoryResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Get HR history
     *
     * @generated from rpc msh.service.v1.StructureManager.GetHRHistory
     */
    getHRHistory: {
      name: "GetHRHistory",
      I: GetHRHistoryRequest,
      O: GetHRHistoryResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Get Sensors history
     *
     * @generated from rpc msh.service.v1.StructureManager.GetSensorHistory
     */
    getSensorHistory: {
      name: "GetSensorHistory",
      I: GetSensorHistoryRequest,
      O: GetSensorHistoryResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc msh.service.v1.StructureManager.GetTemperatures
     */
    getTemperatures: {
      name: "GetTemperatures",
      I: GetTemperaturesRequest,
      O: GetTemperaturesResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc msh.service.v1.StructureManager.GetHumidities
     */
    getHumidities: {
      name: "GetHumidities",
      I: GetHumiditiesRequest,
      O: GetHumiditiesResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc msh.service.v1.StructureManager.GetPressures
     */
    getPressures: {
      name: "GetPressures",
      I: GetPressuresRequest,
      O: GetPressuresResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc msh.service.v1.StructureManager.GetAirQualities
     */
    getAirQualities: {
      name: "GetAirQualities",
      I: GetAirQualitiesRequest,
      O: GetAirQualitiesResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc msh.service.v1.StructureManager.GetLightIntensities
     */
    getLightIntensities: {
      name: "GetLightIntensities",
      I: GetLightIntensitiesRequest,
      O: GetLightIntensitiesResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc msh.service.v1.StructureManager.SetWanderingSettings
     */
    setWanderingSettings: {
      name: "SetWanderingSettings",
      I: SetWanderingSettingsRequest,
      O: SetWanderingSettingsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc msh.service.v1.StructureManager.CalculateStatistics
     */
    calculateStatistics: {
      name: "CalculateStatistics",
      I: CalculateStatisticsRequest,
      O: CalculateStatisticsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc msh.service.v1.StructureManager.StartTestCoverage
     */
    startTestCoverage: {
      name: "StartTestCoverage",
      I: StartTestCoverageRequest,
      O: StartTestCoverageResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc msh.service.v1.StructureManager.StopTestCoverage
     */
    stopTestCoverage: {
      name: "StopTestCoverage",
      I: StopTestCoverageRequest,
      O: StopTestCoverageResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc msh.service.v1.StructureManager.StopTestCoverageTimeout
     */
    stopTestCoverageTimeout: {
      name: "StopTestCoverageTimeout",
      I: StopTestCoverageTimeoutRequest,
      O: StopTestCoverageTimeoutResponse,
      kind: MethodKind.Unary,
    },
  }
};

